import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { MessageService } from 'primeng/api';
import { TermscodeLookupComponent } from '../termscode-lookup/termscode-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GSTTreatment } from '../../../model/common/common.model';

@Component({
  selector: 'app-create-quick-customer-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-customer-lookup.component.html',
  styleUrl: './create-quick-customer-lookup.component.scss'
})
export class CreateQuickCustomerLookupComponent implements OnInit {
  @Output() CustomerId = new EventEmitter<any>();
  constructor(public dialogService: DialogService, private customerService: CustomerService, private messageService: MessageService) { }
  ref: DynamicDialogRef = new DynamicDialogRef;


  customerForm = new FormGroup({
    type: new FormControl('', Validators.required),
    // customerCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9]*$/)]),
    customerCode: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9/-]*$/)]),
    manualEntry: new FormControl(false),
    CustomerImage: new FormControl(),
    contact: new FormControl(""),
    customerName: new FormControl('', Validators.required),
    customerDescription: new FormControl(''),
    // isActive: new FormControl(true),
    isActive: new FormControl(true, Validators.requiredTrue),
    IsShipToCustomer: new FormControl(true),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', Validators.required),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      CreatedBy: new FormControl(''),
    }),
    taxid: new FormControl(''),
    phone: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    mobile: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
    email: new FormControl('', [Validators.email]),
    website: new FormControl(''),
    tags: new FormControl(''),
    createdBy: new FormControl(''),
    GSTIN: new FormControl(''),
    termsCode: new FormControl(),
    termsDescription: new FormControl(),
    gstTreatment: new FormControl<GSTTreatment | null>(null, Validators.required),
  });

  submitted: boolean = false;
  loader: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];
  customerId: number | undefined;
  gstTreatmentList: GSTTreatment[] = [];

  // ngOnInit(): void {
  //   this.manualEntry();
  //   this.getStateList();
  //   this.loadGSTTreatment();

  //   this.customerForm.get('gstTreatment')?.valueChanges
  //     .subscribe((treatment: GSTTreatment | null) => {
  //       if (treatment) {
  //         this.onGSTTreatmentChange(treatment);
  //       }
  //     });

  // }

  ngOnInit(): void {

    this.manualEntry();

    this.getStateList();

    this.loadGSTTreatment(() => {

      this.customerForm.get('gstTreatment')?.valueChanges
        .subscribe((treatment: GSTTreatment | null) => {

          if (!treatment) return;

          this.onGSTTreatmentChange(treatment);

          this.handleStateByGSTTreatment(treatment);
        });
    });

    this.customerForm.get('address.country')?.valueChanges
      .subscribe(country => {
        this.handleCountryChange(country as string);
      });

    this.customerForm.get('GSTIN')?.valueChanges
      .subscribe(() => {
        this.validateGSTINState();
      });
  }

  handleStateByGSTTreatment(treatment: GSTTreatment) {

    const isOverseas = treatment.isOverseas ?? false;

    if (isOverseas) {

      const other = this.stateList.find(x => x.stateCode === '96');

      this.filterStates = other ? [other] : [];

      this.customerForm.patchValue({
        address: {
          state: other?.stateName,
          stateCode: other?.stateCode,
          country: 'Other Country',
          zip: "999999"
        },
        //pos: '96'
      });

    } else {
      this.filterStates = this.stateList.filter(x => x.stateCode !== '96');
    }
  }

  handleCountryChange(country: string) {

    if (country?.toLowerCase() !== 'india') {

      const other = this.stateList.find(x => x.stateCode === '96');

      this.filterStates = other ? [other] : [];

      this.customerForm.patchValue({
        address: {
          state: other?.stateName,
          stateCode: '96',
          country: 'Other Country',
          zip: "999999"
        },
        //pos: '96'
      });

    } else {
      this.filterStates = this.stateList.filter(x => x.stateCode !== '96');
    }
  }

  validateGSTINState() {
    const gstin = this.customerForm.get('GSTIN')?.value;
    const stateCode = this.customerForm.get('address.stateCode')?.value;

    if (!gstin || !stateCode) return;

    const gstState = gstin.substring(0, 2);

    if (gstState !== stateCode) {
      this.customerForm.setErrors({ stateMismatch: true });
    } else {
      this.customerForm.setErrors(null);
    }
  }


  get formControls() {
    return this.customerForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.customerForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  checkCustomerCode() { }

  // manualEntry() {
  //   this.loader = true;
  //   this.customerService.autogenerateCustomerCode().subscribe({
  //     next: (data: any) => {
  //       // const alphanumericCode = 'C';
  //       // const customerCode = alphanumericCode + data;
  //       this.customerForm.controls.customerCode.setValue(data.fullNumber);
  //       this.loader = false;
  //     },
  //     error: error => {
  //       console.log(error);
  //       this.loader = false;
  //     }
  //   });
  // }


  manualEntry() {
    const manualEntryValue = this.customerForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.customerForm.controls.customerCode.setValue('');
    } else {
      this.getCustomerCode();
    }
  }
  getCustomerCode() {
    this.loader = true;
    this.customerService.autogenerateCustomerCode().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'C';
        // const customerCode = alphanumericCode + data;
        this.customerForm.controls.customerCode.setValue(data.fullNumber);
        this.loader = false;
        this.customerId = data;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }



 /*getStateList() {
    this.loader = true;
    this.customerService.getStateList().subscribe({
      next: (data: any) => {
        this.stateList = data;
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  } */
 

//arranged in alphabetically order 

  getStateList() 
  {
  this.customerService.getStateList().subscribe({
    next: (data: any) => {
      this.stateList = (data ?? []).sort((a: any, b: any) =>
        (a.stateName ?? a.name ?? a.label ?? '').localeCompare(
          b.stateName ?? b.name ?? b.label ?? ''
        )
      );
    },
    error: error => {
      console.log(error);
    }
  });
}



  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.customerForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.customerForm.controls.GSTIN.setValue(event.value.stateCode);

  // }

  setState(event: any) {
    this.customerForm.patchValue({
      GSTIN: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });

  }

  checkState() {
    const enteredState = this.customerForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
    } else {
      this.customerForm.controls.address.controls.state.setValue('');
    }
  }

  validater() {
    const customerCodeControl = this.customerForm.get('customerCode');
    const mobileControl = this.customerForm.get('mobile');
    if (mobileControl?.invalid) {
      if (mobileControl.errors?.['pattern']) { }
      if (mobileControl.errors?.['maxlength']) { }
    }
    if (customerCodeControl?.invalid) {
      if (customerCodeControl.errors?.['required']) {
      }
      if (customerCodeControl.errors?.['pattern']) {
      }
    }
  }

  createCustomer(data: any) {

    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }

    const username = localStorage.getItem('username') || 'system';

    const formValue = this.customerForm.value;

    const payload = {
      ...formValue,

      createdBy: username,

      gstTreatmentCode: formValue.gstTreatment?.code,

      gstTreatment: undefined 

    };

    this.loader = true;
    this.customerService.createCustomer(payload).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response.success === true) {
          this.CustomerId.emit(response.id);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Customer created successfully.' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: response.message });
        }
      },
      error: error => {
        this.loader = false;
        console.error('Error creating customer:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while creating the customer. Please try again later.' });
      }
    });
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.customerForm.patchValue({
          termsCode: data.termsCode,
          termsDescription: data.paymentTermsDescription
        })
      }
    })
  }

  loadGSTTreatment(callback?: () => void) {
    this.customerService.getGSTTreatments()
      .subscribe({
        next: (res: GSTTreatment[]) => {
          //console.log(res);

          this.gstTreatmentList = res;

          if (callback) {
            callback();
          }
        },
        error: (err) => {
          console.error('Error loading GST Treatments', err);
        }
      });
  }

  onGSTTreatmentChange(treatment: GSTTreatment | null) {
    const gstinControl = this.customerForm.get('GSTIN');
    if (!gstinControl) return;

    const allows = treatment?.allowsGSTIN ?? false;

    gstinControl.clearValidators();
    gstinControl.setValue(null);

    if (allows) {
      gstinControl.enable(); // enable first
      gstinControl.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9A-Z]{15}$/)
        //Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
      ]);
    } else {
      gstinControl.disable(); // disable cleanly
    }

    gstinControl.updateValueAndValidity({ emitEvent: false });
  }

}
